export const locales = {
    'en-us': {
        link_external: 'external site',
        secure: 'secure',
        item: '{{count}} item',
        item_plural: '{{count}} items',
        loading: 'Loading...',
        error: 'There was an error loading data.',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        save: 'Save',
        cancel: 'Cancel',
        review: 'Review',
        finish: 'Finish',
        submit: 'Submit',
        state: 'State',
        country: 'Country',
        step: 'Step',
        question: 'Question',
        answer: 'Answer',
        of: 'out of',
        unanswered: 'unanswered',
        na: 'N/A',
        show: 'Show',
        hide: 'Hide',
        menu: 'Menu',
        backToTop: 'Top',
        optional: '(optional)',
        fieldRequired: 'This field is required.',
        required: " is required.",
        invalid: " is invalid",
        goodMorning: 'Good Morning!',
        goodAfternoon: 'Good Afternoon!',
        goodEvening: 'Good Evening!',
        search: 'Search',
        searchError: 'A search value is required.',
        yes: "Yes",
        no: "No"
    },
    'es-us': {
        link_external: 'sitio externo',
        secure: 'seguro',
        item: '{{count}} artículo',
        item_plural: '{{count}} artículo',
        loading: 'Cargando...',
        error: 'Hubo un error al cargar los datos.',
        close: 'Cerrar',
        back: 'Atrás',
        next: 'Siguiente',
        save: 'Guardar',
        cancel: 'Cancelar',
        review: 'Revisar',
        finish: 'Terminar',
        submit: 'Enviar',
        state: 'Estado',
        country: 'País',
        step: 'Paso',
        question: 'Pregunta',
        answer: 'Respuesta',
        of: 'de',
        unanswered: 'sin respuesta',
        na: 'No corresponde',
        show: 'Mostrar',
        hide: 'Ocultar',
        menu: 'Menú',
        backToTop: 'Volver',
        optional: '(opcional)',
        fieldRequired: 'Este campo es requerido.',
        required: " es requerido.",
        invalid: " es inválido",
        goodMorning: '¡Buenos días!',
        goodAfternoon: '¡Buenas tardes!',
        goodEvening: '¡Buenas noches!',
        search: 'Búsqueda',
        searchError: 'Se requiere un valor de búsqueda.',
        yes: "Sí",
        no: "No"
    },
};
//# sourceMappingURL=internal-locales.js.map